import type {GridApi, GridReadyEvent} from "ag-grid-community";
import {useCallback, useRef} from "react";

export const useAgGridApi = () => {
  const apiRef = useRef<GridApi | null>(null);

  const onGridReady = useCallback((params: GridReadyEvent) => {
    apiRef.current = params.api;
  }, []);

  return {
    apiRef,
    onGridReady
  };
};
